/**
 * @module store/emails/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив e-mails (текущую "страницу")
 *
 * @returns {array}
 */
const users = state => state.users;


/**
 * Getter: Возвращает общее число e-mails
 *
 * @returns {number}
 */
const usersCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент e-mails
 *
 * @returns {boolean}
 */
const isUsersLoading = state => state.isLoading;


export default {
  isUsersLoading,
  users,
  usersCount,
};
